<ion-header>
  <app-no-internet-connection></app-no-internet-connection>
  <app-ionic-update-error></app-ionic-update-error>
  <ion-toolbar>
    <ion-title> {{ pageTitle ? pageTitle : "Custom Page" }} </ion-title>
    <ion-buttons slot="start">
      <ion-menu-button color="dark"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row *ngIf="loading" style="width: 100%">
      <ion-col class="ion-text-center">
        <ion-spinner></ion-spinner>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!loading && !pageDescriptionText" style="width: 100%">
      <ion-col class="ion-text-center">
        <ion-text color="medium">No page content found.</ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!loading && pageDescriptionText" style="width: 100%">
      <ion-col size="12">
        <div
          class="customPageDescription"
          [innerHTML]="pageDescriptionText"
        ></div>
      </ion-col>

      <ion-col size="12" *ngIf="pageButtons && pageButtons.length">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="12"
              *ngFor="let button of pageButtons"
              class="customPageButtonColumn"
            >
              <ion-button
                class="customPageButton"
                fill="solid"
                color="primary"
                (click)="openButtonUrl(button)"
              >
                {{ button.label }}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
